
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 15 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14.148 20h-3.494V2.703h-1.56c-2.858 0-4.352 1.429-4.352 3.56 0 2.418 1.033 3.54 3.165 4.968l1.758 1.187L4.61 20H.852l4.55-6.77C2.785 11.364 1.312 9.54 1.312 6.463 1.313 2.615 3.994 0 9.071 0h5.056l.021 20z","fill":"currentColor"}})])
          )
        }
      }
    